module.exports = __webpack_public_path__ + "img/apeswap.c098f0b3.png";